import { Select, SelectProps } from "@chakra-ui/react";
import { useField } from "formik";
import React from "react";
import { BaseProps } from "../baseProps";
import { FormControl } from "../FormControl";

export interface ISelectOption {
  label: string;
  value: string;
}
export type SelectComponentProps = BaseProps &
  SelectProps & {
    options: ISelectOption[];
    placeholder?: string;
    defaultValue?: string;
    value?: string;
    description?: string;
    isIncludeDescription?: boolean;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onBlur?: (event: React.FocusEvent<any> | undefined) => void;
  };

export const SelectComponent = (props: SelectComponentProps) => {
  const {
    label,
    description,
    isIncludeDescription,
    placeholder = "Select...",
    formControlProps,
    // inputLeftIcon,
    ...rest
  } = props;

  const { error, touched, ...formControlPropsRest } = formControlProps || {};

  return (
    <FormControl
      label={label}
      error={error}
      description={description}
      isIncludeDescription={isIncludeDescription}
      touched={touched}
      {...formControlPropsRest}
    >
      <Select
        defaultValue={rest.defaultValue}
        placeholder={placeholder}
        {...rest}
      >
        {rest.options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export type FormSelectComponentProps = Omit<
  SelectComponentProps,
  "value" | "onChange"
>;

export const FormSelectControl = (props: FormSelectComponentProps) => {
  const [field, meta, { setValue, setTouched }] = useField(props.name);

  const selectedOption = props.options.find(
    (option) => option.value === field.value
  );

  const handleChange = (evt) => {
    const value = evt.target.value;

    if (value) {
      setValue(value);
    } else {
      setValue("");
    }
  };

  const handleBlur = () => setTouched(true);

  return (
    <SelectComponent
      {...field}
      formControlProps={{ ...meta }}
      value={selectedOption?.value}
      onChange={handleChange}
      onBlur={handleBlur}
      {...props}
    />
  );
};
